import React from "react";

import { ITicketFormData } from "app/containers/Features/containers/Boards/containers/Tickets/types";
import { ITicketTypes } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import AssigneeDropdown from "app/containers/Features/containers/Ticket/components/TicketDetailsComponent/TicketDetails/AssigneeDropdown";
import DueDateSelection from "app/containers/Features/containers/Ticket/components/TicketDetailsComponent/TicketDetails/DueDateSelection";
import PriorityDropdown from "app/containers/Features/containers/Ticket/components/TicketDetailsComponent/TicketDetails/PriorityDropdown";
import ProjectSelection from "app/containers/Features/containers/Ticket/components/TicketDetailsComponent/TicketDetails/ProjectSelection";
import StatusDropdown from "app/containers/Features/containers/Ticket/components/TicketDetailsComponent/TicketDetails/StatusDropdown";
import TagsSelection from "app/containers/Features/containers/Ticket/components/TicketDetailsComponent/TicketDetails/TagsSelection";
import TeamSelection from "app/containers/Features/containers/Ticket/components/TicketDetailsComponent/TicketDetails/TeamSelection";
import TicketTypeDropdown from "app/containers/Features/containers/Ticket/components/TicketDetailsComponent/TicketDetails/TicketTypeDropdown";
import {
  IWorkspaceProjects,
  IWorkspaceTeams,
  PriorityFilterEnum,
} from "app/types";

interface Props {
  form: ITicketFormData;
  ticketTypes: ITicketTypes[];
  projectId: string;
  selectedTeam: IWorkspaceTeams;
  selectedProject: IWorkspaceProjects;
  setValue: (name: string, id: string | string[]) => void;
  isAddEpicModal?: boolean;
}
export const getFieldRenderers = ({
  form,
  setValue,
  ticketTypes,
  selectedTeam,
  selectedProject,
  isAddEpicModal = false,
}: Props) => ({
  teamName: <TeamSelection selectedTeam={selectedTeam} />,

  projectName: <ProjectSelection selectedProject={selectedProject} />,

  ticketType: (
    <TicketTypeDropdown
      value={form.type}
      setValue={(v) => setValue("type", v)}
      ticketTypes={ticketTypes}
      isAddEpicModal={isAddEpicModal}
      epicColor={form.color}
    />
  ),

  status: (
    <StatusDropdown
      value={form.status}
      setValue={(v) => setValue("status", v)}
    />
  ),

  assignee: (
    <AssigneeDropdown
      assignedTo={form.assignedTo}
      onUpdate={(v) => setValue("assignedTo", v)}
    />
  ),

  dueDate: (
    <DueDateSelection
      dueDate={form.dueDate}
      onDateChange={(v) => setValue("dueDate", v as string)}
    />
  ),

  priority: (
    <PriorityDropdown
      value={form.priority as PriorityFilterEnum}
      setValue={(v) => setValue("priority", v)}
    />
  ),

  tags: (
    <TagsSelection
      tagIds={form.tags}
      onTagsChange={(v) => setValue("tags", v)}
    />
  ),
});
